import { render, staticRenderFns } from "./ShRecipesCard.vue?vue&type=template&id=6621bad0&scoped=true&"
import script from "./ShRecipesCard.vue?vue&type=script&lang=js&"
export * from "./ShRecipesCard.vue?vue&type=script&lang=js&"
import style0 from "./ShRecipesCard.vue?vue&type=style&index=0&id=6621bad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6621bad0",
  null
  
)

export default component.exports